import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.903 5.866h7.102c.799 0 1.597-.294 2.097-.88 1.197-1.173 1.197-3.03 0-4.106C9.717.545 9.053 0 8.005 0S6.408.293 5.909.88a.93.93 0 0 0 0 1.369.98.98 0 0 0 1.397 0c.2-.196.4-.294.7-.294s.498.098.698.294c.4.39.4.977 0 1.368-.2.196-.4.294-.699.294H.903c-.599 0-.903.39-.903.977s.304.978.903.978m.095 7.82c-.599 0-.998.392-.998.978 0 .587.4.978.998.978h10.009c.3 0 .499.097.698.293.2.195.3.39.3.684 0 .293-.1.489-.3.684s-.399.294-.698.294a.92.92 0 0 1-.699-.294.98.98 0 0 0-1.396 0c-.4.392-.4.978 0 1.37q.897.879 2.095.879 1.197 0 2.095-.88T14 16.619c0-.782-.3-1.564-.898-2.053-.499-.586-1.297-.88-2.095-.88zm18.028-8.749c-1.399-1.369-3.596-1.369-4.895 0a.93.93 0 0 0 0 1.369.98.98 0 0 0 1.398 0 1.47 1.47 0 0 1 2.098 0c.6.586.6 1.466 0 2.053-.3.293-.699.454-1.098.454H.952c-.599 0-.952.377-.952.963 0 .587.353.929.952.929H16.53c.899 0 1.798-.391 2.497-.978 1.299-1.27 1.299-3.421 0-4.79z"
    }, null, -1)
  ]))]))
}
export default { render: render }